

export const DEFAULT_ACCOUNT_ROUTE_NAME = 'account';
export const DEFAULT_PROJECT_ROUTE_NAME = 'projectDetails';
